const translations = JSON.parse(window.translations);
export default function t (string) {
    return translations[string] ?? string;
}
